import z from "zod";

import { basicValidator } from "@/utils/core/validators";

export const AddVariationSchema = z.object({
  name: basicValidator(true, "Variation name cannot be empty", 1, 300, true),
});

export const AddQuoteVersionSchema = z.object({
  quoteVersion: basicValidator(true, "Quote version is required", 1, 300),
});
